"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const Swatch_1 = __importDefault(require("./partials/Swatch"));
const product_swatch_module_scss_1 = __importDefault(require("./product-swatch.module.scss"));
/**
 * Renders the swatches/fabrics buttons for a product
 * @param {Object} props
 * @param {string} props.className
 * @param {{ value: string; label: string; background: string; }[]} props.optionsList
 * @param {string} props.productCode
 * @param {string} props.initialSelection
 * @param {string} props.swatchClasses
 * @param {function} props.onChange
 * @param {string} props.inputIdModifier
 * @param {('small' | 'medium')} props.size
 * @returns {import('react').ReactNode}
 */
const ProductSwatch = ({ className, optionsList, productCode, initialSelection, swatchClasses, onChange = () => { }, inputIdModifier = '', size = 'medium' }) => {
    const [selectedValue, setSelectedValue] = (0, react_1.useState)(initialSelection);
    (0, react_1.useEffect)(() => { setSelectedValue(initialSelection); }, [initialSelection]);
    const handleInputChange = (value) => {
        setSelectedValue(value);
        onChange(value);
    };
    const classes = (0, classnames_1.default)(product_swatch_module_scss_1.default.productSwatch, className);
    const swatchClassNames = (0, classnames_1.default)(product_swatch_module_scss_1.default.swatch, swatchClasses);
    return ((0, jsx_runtime_1.jsx)("div", { id: `product-option-${productCode}-${inputIdModifier}`, className: classes, role: "radiogroup", children: optionsList.map((option) => {
            const isSelected = option.value === selectedValue;
            return (0, jsx_runtime_1.jsx)(Swatch_1.default, { size: size, isSelected: isSelected, className: swatchClassNames, onChange: handleInputChange, productCode: productCode, ...option }, option.value);
        }) }));
};
ProductSwatch.propTypes = {
    className: prop_types_1.default.string,
    inputIdModifier: prop_types_1.default.string,
    optionsList: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        value: prop_types_1.default.string.isRequired,
        label: prop_types_1.default.string.isRequired,
        background: prop_types_1.default.string.isRequired,
    })),
    onChange: prop_types_1.default.func,
    initialSelection: prop_types_1.default.string,
    productCode: prop_types_1.default.string,
    swatchClasses: prop_types_1.default.string,
    size: prop_types_1.default.oneOf(['small', 'medium'])
};
exports.default = ProductSwatch;
//# sourceMappingURL=product-swatch.js.map